import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import { CommonTable } from 'gnos-tables'
import _ from 'lodash'

import CustomDate from '../../../../../../../../../../../../../components/CustomDate'
import Money from '../../../../../../../../../../../../../components/TableCell/components/Money'

import { LOCALE_PREFIX } from '../../../../constants'

@injectIntl
export default class Table extends Component {
    static propTypes = {
        data: PropTypes.array,
        id: PropTypes.string.isRequired,
        intl: PropTypes.object,
    }

    render() {
        const { id, data, intl } = this.props

        return (
            <div className={'alza-scoring-data-table'}>
                <CommonTable
                    key={`alza-scoring-common-table-${id}`}
                    id={`alza-scoring-common-table-${id}`}
                    columnsDefinition={[
                        {
                            accessor: 'ratingText',
                            width: 200,
                            Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.scoringLevel` }),
                        },
                        {
                            width: 200,
                            accessor: 'probability',
                            Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.declineProbability` }),
                            Cell: ({ value }) => <span>{value ? `${value} %` : '-'}</span>,
                        },
                        {
                            accessor: 'minTransactionLimit',
                            Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.transactionLimit` }),
                            Cell: ({ value, original }) => {
                                if (_.isEmpty(value) && _.isEmpty(original?.maxTransactionLimit)) return 'N/A'

                                return (
                                    <div className={'limit-cell'}>
                                        {value && (
                                            <Money
                                                value={value}
                                                showCurrency={
                                                    !original?.maxTransactionLimit ||
                                                    value?.amount === original?.maxTransactionLimit?.amount
                                                }
                                                emptyValue={'N/A'}
                                            />
                                        )}
                                        {value &&
                                            original?.maxTransactionLimit &&
                                            value?.amount !== original?.maxTransactionLimit?.amount && (
                                                <span style={{ paddingRight: '4px' }}>{'-'}</span>
                                            )}
                                        {original?.maxTransactionLimit &&
                                            value?.amount !== original?.maxTransactionLimit?.amount && (
                                                <Money
                                                    value={original?.maxTransactionLimit}
                                                    showCurrency
                                                    emptyValue={'N/A'}
                                                />
                                            )}
                                    </div>
                                )
                            },
                        },
                        {
                            accessor: 'minCreditLimit',
                            Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.creditLimit` }),
                            Cell: ({ value, original }) => {
                                if (_.isEmpty(value) && _.isEmpty(original?.maxCreditLimit)) return 'N/A'

                                return (
                                    <div className={'limit-cell'}>
                                        {value && (
                                            <Money
                                                value={value}
                                                showCurrency={
                                                    !original?.maxCreditLimit ||
                                                    value?.amount === original?.maxCreditLimit?.amount
                                                }
                                                emptyValue={'N/A'}
                                            />
                                        )}
                                        {value &&
                                            original?.maxCreditLimit &&
                                            value?.amount !== original?.maxCreditLimit?.amount && (
                                                <span style={{ paddingRight: '4px' }}>{'-'}</span>
                                            )}
                                        {original?.maxCreditLimit &&
                                            value?.amount !== original?.maxCreditLimit?.amount && (
                                                <Money
                                                    value={original?.maxCreditLimit}
                                                    showCurrency
                                                    emptyValue={'N/A'}
                                                />
                                            )}
                                    </div>
                                )
                            },
                        },
                        {
                            accessor: 'startDate',
                            width: 120,
                            Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.startDate` }),
                            Cell: (startDate) => (
                                <CustomDate date={startDate?.value?.value} precision={startDate?.value?.precision} />
                            ),
                        },
                        {
                            accessor: 'endDate',
                            width: 120,
                            Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.endDate` }),
                            Cell: (startDate) => (
                                <CustomDate date={startDate?.value?.value} precision={startDate?.value?.precision} />
                            ),
                        },
                    ]}
                    staticData={{
                        _table: data,
                    }}
                />
            </div>
        )
    }
}
